<template>
  <div class="value-road-map-display">
    <div class="value-road-map-moat-comps">
      <div class="need-display">
        <div class="description">
              Organizations that possess a similar digital profile of expectation across their full customer base. A 100% fit is a complete digital twin.
        </div>
       </div>
       <div>
          <div class="moat-name">Moat Comps</div>
          <div class="card-display pt-2" style="height: 250px">
              <moat-comps-body 
                :display-dashboard="displayMoatComps"
                :rankings-by-company="moatCompsData.rankingsByCompany" 
                :rankings-by-framework="moatCompsData.rankingsByFramework" 
                :not-enough-data="moatCompsData.notEnoughData"
                :no-data="moatCompsData.noData"/>
          </div>
        </div>       
    </div>
    <div class="value-road-map-focus-area">
      <div class="focus-area-container">
        <div v-for="(focusArea, idxFocusAreas) in this.valueRoadMapDisplayData" v-bind:key="idxFocusAreas" class="focus-area-item">
            <div class="need-display">
              <div class="needs-header">{{ focusArea.needName }}</div>
              <div class="wtp-score">{{focusArea.wtpScore }}</div>
            </div>
            <div class="moat-display">
              <div class="moat-name">{{ focusArea.moatName }}</div>
              <div class="moat-comps-container">
                <div class="moat-comps-results">
                  <div v-for="(historicalExample, idxHistoricalExamples) in focusArea.historicalExamples" v-bind:key="idxHistoricalExamples" class="company-image">
                      <div :class="historicalExample"></div>                
                  </div>
                </div>
              </div>
              <div class="moat-description">
                {{ focusArea.description }}
              </div>
              <div class="moat-description-show-more">
                <span v-show="focusArea.description.length >= 125" @click="showContent(focusArea)" class="show-more-link">
                  {{ focusArea.showMore ? "Show Less" : "Show More" }}
                </span>
              </div>
            </div>
            <div class="initiative-display">
              <div class="initiative">{{ focusArea.initiative }}</div>              
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MoatCompsBody from "../dashboard/body/MoatCompsBody.vue";
import AlertService from "../../services/alert.service";

export default {

  name: "ValueRoadMapDisplay",
  mixins: [],
  components: {  MoatCompsBody},
    props: {
      moatCompsData: {
        type: Object,
        default: function() {
          return {
            noData: true,
            notEnoughData: true,
            rankingsByCompany: [],
            rankingsByFramework: [],            
          };
        }
      },      
      valueRoadMapDisplayData: {
        type: Array,
        default: function() {
          return [];
        }
      }
  },
  data() {
    return {
      enabled: true,
      displayMoatComps: false,
    };
  },
  methods: {  
    showContent: function(focusArea) {
      AlertService.showModalContentMessage('Moat Description', focusArea.description);
    }
  },
  created() {

  },
  mounted() {},
  watch: {
    moatCompsData: function() {
      if (this.moatCompsData && this.moatCompsData.rankingsByCompany && this.moatCompsData.rankingsByFramework) {
        this.displayMoatComps = true;
      } else {
        this.displayMoatComps = false;
      }
    }
  },
  computed: {
  }
};
</script>
